import * as React from 'react';

import { renderEmpty } from '../../common/Render';

import { IReportSettings, SU } from '../../../../interfaces';

import ISettings from './ISettings';
import IWidgetProps from './IWidgetProps';
import JobTable from './JobTable';


interface IProps extends IWidgetProps {
    settings: ISettings;
}

export default class Widget extends React.Component<IProps, {}> {
    static propTypes = {
        systems: React.PropTypes.array.isRequired,
        jobs: React.PropTypes.object.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    renderData(nodes: SU.ISystem[], settings: ISettings, _reportSettings: IReportSettings) {
        const byParent = nodes.reduce((map, node) => {
            const parentId = node._searchIdx.parentNames.slice(2).join(' / ');

            if (!map[parentId]) {
                map[parentId] = [];
            }

            map[parentId].push(node);

            return map;
        }, {});

        const parents = Object.keys(byParent).sort();

        return parents.map(function (parent) {
            const parentKey = `parent-${parent}`;

            const children = byParent[parent].map((node) => {
                const nodeKey = `node-${node.id}`;
                return (
                    <div key={nodeKey}>
                        <JobTable title={node.name} jobs={node.jobs} settings={settings} />
                    </div>
                );
            });

            return (
                <div key={parentKey} className="space-xl">
                    <h4>{parent}</h4>
                    {children}
                </div>
            );
        });
    }

    render() {
        let { systems } = this.props;
        const { settings, reportSettings } = this.props;

        systems = systems.filter((system: SU.ISystem) => {
            if (!settings.displaySystemsWithoutJobs) {
                return system.jobs.length > 0;
            }

            return true;
        });

        let renderedData;
        if (systems && systems.length) {
            renderedData = this.renderData(systems, settings, reportSettings);
        } else {
            renderedData = renderEmpty();
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/su/listJobs/Widget.tsx